<template>
  <div class="alignCenter">
    <van-nav-bar title="预约详情" id="reset" />
    <!-- <van-cell-group v-show="!hasBooked">
      <van-cell title="您还未预约" value="请先预约" />
    </van-cell-group>
    <van-button @click="goToIndex" type="info" block>预约</van-button> -->

    <div style="margin-bottom:80px;padding-bottom:80px">
      <van-field
        label="姓名"
        v-model="formBasicInfo.name"
        name="pattern"
        placeholder="姓名"
        :readonly="true"
      />
      <van-field
        label="年龄"
        :value="age"
        name="pattern"
        placeholder="年龄"
        :readonly="true"
      />
      <van-field
        label="预约时间"
        v-model="form.bookedTime"
        name="pattern"
        placeholder="预约时间"
        :readonly="true"
      />
      <van-field
        label="预约地点"
        v-model="form.medResourceName"
        name="pattern"
        placeholder="预约地点"
        :readonly="true"
      />
      <div class="credential_container">
        <h3>预约凭证</h3>
        <h3>您的电话：{{formBasicInfo.userInfoTeleNum}}</h3>
      </div>
      <van-button type="info" block color="#4285C3" @click="goToReport" class="btn"
        >查看诊断报告</van-button
      >
      <van-button
        class="btn"
        type="danger"
        block
        color="#E3593B"
        @click="_cancelBookedResource"
        >取消预约</van-button
      >
    </div>

    <van-tabbar
      class="bottomBar"
      active-color="#FFFFFF"
      inactive-color="#FFFFFF"
    >
      <van-tabbar-item name="home" icon="home-o" @click="goToIndex" 
        >首页</van-tabbar-item
      >
      <van-tabbar-item name="setting" icon="setting-o" @click="goToBookRecord"  
        >预约记录</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script type="text/ecmascript-6">
import credentialBG from "../../../assets/credential.png";
import {
  getUserBookedResource,
  getCurrentUserByToken,
  getUserInfo,
  cancelBookedResource,
} from "../../../api/userService";
export default {
  name: "login",
  // components:{
  //   ,
  // },
  data() {
    return {
      credentialBG,
      hasBooked: false,
      teleNum: sessionStorage.getItem("teleNum"),
      form: {
        bookedTime: "",
        medResourceName: "",
      },
      formBasicInfo: {
        name: "",
        birthDate: "",
        userInfoTeleNum: "",
      },
    };
  },
  computed: {
    age() {
      return (
        new Date().getFullYear() -
        new Date(this.formBasicInfo.birthDate.replace(/-/g, "/")).getFullYear()
      );
    },
  },
  // 创建完毕状态(里面是操作)
  created() {
    this._getUserBookedResource();
    this._getCurrentUser();
  },
  // 里面的函数只有调用才会执行
  methods: {
    //获取当前用户信息
    _getCurrentUser() {
      getCurrentUserByToken()
        .then((res) => {
          if (res.userInfo) {
            this.formBasicInfo = res.userInfo;
          } else {
            this._getUserInfo();
          }
        })
        .catch((e) => {
          this._getUserInfo();
          this.$message({
            message: "获取当前用户信息失败," + e,
            type: "error",
          });
        });
    },
    _getUserInfo() {
      //我的诊断中获取用户基本信息
      getUserInfo(this.teleNum).then((res) => {
        //基础信息
        if (res.data[0]) {
          this.formBasicInfo = res.data[0];
        }
      });
    },
    //获取用户预约的资源
    _getUserBookedResource(reloadData) {
      getUserBookedResource(this.teleNum)
        .then((res) => {
          //如果接口调用成功，且有预约资源（res.data存在 ）
          if (res.success) {
            //如果有预约记录,则将状态设置为已经预约
            if (res.data) {
              this.hasBooked = true;
              
              this.form.bookedTime = res.data[0].checkTime;
              this.form.medResourceName = res.data[0].medResourceName;

              if (reloadData) {
                reloadData();
              }
            }
          } else {
            //没有预约资源的提示
            this.$message({
              message: "发现您还未预约，欢迎来预约检查",
              type: "info",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
          });
        });
    },
    handleClick() {},
    _cancelBookedResource() {
      cancelBookedResource(this.formBasicInfo.userInfoTeleNum)
        .then((res) => {
          if (res.success) {
            // this.$notify({ message: res.description, type: "success" });
            this.$toast.success('取消成功');
            this.$router.push({ path: "/appIndex/main" });
          } else {
            // this.$notify({ message: res.description, type: "error" });
            this.$toast.fail('取消失败');
          }
        })
        .catch((e) => {
          this.$notify({ message: e, type: "error" });
        });
    },
    goToIndex() {
      this.$router.push({ path: "/appIndex/main" });
    },
    goToBookRecord() {
      this.$router.push({ path: "/appIndex/appointmentResult" });
    },
    goToReport() {
      this.$router.push({ path: "/appIndex/checkReport" });
    },
  },
};
</script>

<style lang=less scoped>

/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/

.btn{
  margin:20px auto;
  width:80%;
  border-radius:10px;
}
.bottomBar {
  background: linear-gradient(to bottom, #77bbe3, #1270c6);
}

.credential_container {
  background-image: url("../../../assets/credential.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  width: 90%;
  height: 100px;
  margin:20px auto;
  text-align:center;
}
.credential_container h3{
  color:white;
}
div.credential_container :first-child{
  padding:15px 0 0 0;
}


/** credential */


</style>